import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { generateYearOptions, monthOptions } from "../utils/dateUtils";

const MonthYearSelector = ({ year, month, onYearChange, onMonthChange }) => {
  const yearOptions = generateYearOptions();

  return (
    <Box sx={{ mb: 3, display: "flex", gap: 2, alignItems: "center" }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id="year-select-label">Year</InputLabel>
        <Select
          labelId="year-select-label"
          id="year-select"
          value={year}
          label="Year"
          onChange={onYearChange}
        >
          {yearOptions.map((yearOption) => (
            <MenuItem key={yearOption} value={yearOption}>
              {yearOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="month-select-label">Month</InputLabel>
        <Select
          labelId="month-select-label"
          id="month-select"
          value={month}
          label="Month"
          onChange={onMonthChange}
        >
          {monthOptions.map((monthOption) => (
            <MenuItem key={monthOption.value} value={monthOption.value}>
              {monthOption.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default MonthYearSelector;
